import { render, staticRenderFns } from "./cadastro-adiciona-senha.vue?vue&type=template&id=a44b9f00&"
import script from "./cadastro-adiciona-senha.vue?vue&type=script&lang=js&"
export * from "./cadastro-adiciona-senha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports